import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, saveSession } from "@/lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/customer/login"); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post(`/auth/google/session`, { session_id: sid });
        saveSession("customer", data);
        // scrub the fragment and go home
        window.history.replaceState(null, "", "/");
        toast.success(`Welcome, ${data.user.name}`);
        nav("/");
      } catch (e) {
        toast.error(e.response?.data?.detail || "Google sign-in failed");
        nav("/customer/login");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center" data-testid="auth-callback">
        <Loader2 className="animate-spin text-orange-500 mx-auto" size={32}/>
        <p className="mt-3 text-slate-600">Finishing Google sign-in…</p>
      </div>
    </div>
  );
}
